{
  "ja": {
    "main_category": "udx_labelinjapanese",
    "sub_category": "udx_nameinjapanese",
    "options": "udx_nameinjapanese"
  },
  "en": {
    "main_category": "udx_name",
    "sub_category": "udx_name",
    "options": "udx_name"
  }
}
